import * as Yup from 'yup';
import { useEffect, useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';

import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
// material
import {
    Link, Stack, Checkbox, TextField, IconButton, InputAdornment, FormControlLabel, Typography, FormControl, FormLabel
} from '@mui/material';
import { useSnackbar } from 'notistack';
import { styled } from '@mui/material/styles';
import { LoadingButton } from '@mui/lab';
import { Icon } from '@iconify/react';
import * as LocalStorage from 'local-storage';
import URLS from '../../../services/urls.service';

import AppCache from '../../../services/AppCache';


// ----------------------------------------------------------------------

export default function LoginForm() {
    const { enqueueSnackbar } = useSnackbar();
    const [disable, setDisable] = useState(false)

    useEffect(() => {
        setDisable(true);

    }, []);
    console.log()
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);

    const LoginSchema = Yup.object().shape({
        email: Yup.string().email('Login ID must be a valid email address').required('Login ID is required'),
        password: Yup.string().required('Password is required')
    });
    const DefaultDashBoardMenuList = [
        {
            MenuAlias: "Issue Tracker For Non SAPL",
            MenuParentName: "Service",
            path: "/dashboard/service/issuetrackerfornonsapl",
        },
    ];
    const formik = useFormik({
        initialValues: {
            email: '',
            password: '',
            ApplicationAccesId: 'TiketicPortalAccessId',
            remember: false
        },

        validationSchema: LoginSchema,
        onSubmit: (values, actions) => {

            const payload = { LoginId: values.email, Password: values.password, ApplicationAccesId: 'TiketicPortalAccessId' };
            URLS.loginURL(payload)
                .then((response) => {
                    console.log("response", response);
                    actions.setSubmitting(false);
                    // Successful response
                    if (response.status === 404) {
                        enqueueSnackbar("invalid Username or Password");
                    }
                    else if (response.status === 200) {
                        AppCache.SetCurrentLoggedInUser(response.data);

                        const defaultMenu = response.data?.DefaultDashBoardMenuList?.[0];

                        if (defaultMenu) {
                            const menuParentName = defaultMenu.MenuParentname
                                ?.toLowerCase()
                                .replace(/\s+/g, "");

                            const menuChildName = defaultMenu.MenuAlias
                                ?.toLowerCase()
                                .replace(/\s+/g, "");

                            const route = `/dashboard/${menuParentName}/${menuChildName}`;

                            console.log("Navigating to:", route);

                            navigate(route, { replace: true });
                        } else {
                            navigate("/dashboard/app", { replace: true });
                        }

                        console.log("Dashboard list", response.data,)

                        // const defaultMenu = DefaultDashBoardMenuList[0];
                        // navigate(defaultMenu.path, { replace: true });
                    }

                    else {
                        // Failure response
                        alert(response);
                    }
                })
                .catch(error => {
                    actions.setSubmitting(false);
                    enqueueSnackbar("invalid Username or Password");

                });

        }

    });
    const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps } = formik;

    const handleShowPassword = () => {
        setShowPassword((show) => !show);
    };

    return (
        <FormikProvider value={formik}>
            <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                <Stack spacing={1} mb={4}>
                    <Typography
                        sx={{
                            width: 289,
                            height: 31,

                            opacity: 1,
                            fontWeight: 600,
                            fontSize: '26px',
                            lineHeight: '100%', // same as your design
                            letterSpacing: '0',
                        }}
                    >
                        Sign in to your account
                    </Typography>

                    <Typography variant="body2" color="text.secondary">
                        Enter your credentials to view all insights
                    </Typography>
                </Stack>
                <Stack direction="column" spacing={2}>
                    <FormControl fullWidth size="small">
                        <FormLabel >Login ID</FormLabel>
                        <TextField
                            fullWidth
                            autoComplete="username"
                            size="small"
                            type="email"
                            {...getFieldProps('email')}
                            error={Boolean(touched.email && errors.email)}
                            helperText={touched.email && errors.email}
                            placeholder="Enter Your Login ID"
                        />
                    </FormControl>
                    <FormControl fullWidth size="small">
                        <FormLabel > Password</FormLabel>
                        <TextField
                            fullWidth
                            size="small"
                            autoComplete="current-password"
                            type={showPassword ? 'text' : 'password'}
                            {...getFieldProps('password')}
                            error={Boolean(touched.password && errors.password)}
                            helperText={touched.password && errors.password}
                            placeholder="Enter Your Password"
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            onClick={() => setShowPassword(prev => !prev)}
                                            edge="end"
                                            sx={{ color: '#BBBBBB', }}
                                        >
                                            {showPassword ? <VisibilityOffOutlinedIcon sx={{ fontSize: 14 }} /> : <VisibilityOutlinedIcon sx={{ fontSize: 14 }} />}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                           
                            sx={{
                                '& input::-ms-reveal': {
                                    display: 'none',
                                },
                                '& input::-ms-clear': {
                                    display: 'none',
                                },
                                '& input::-webkit-credentials-auto-fill-button': {
                                    visibility: 'hidden',
                                    display: 'none !important',
                                },

                                // When input is autofilled → color entire root
                                '& .MuiOutlinedInput-root:has(input:-webkit-autofill)': {
                                    backgroundColor: '#E8F0FE',
                                },

                                // Keep input text correct
                                '& input:-webkit-autofill': {
                                    WebkitBoxShadow: '0 0 0 1000px transparent inset',
                                    WebkitTextFillColor: '#000',
                                },
                            }}
                        />
                    </FormControl>
                    <LoadingButton
                        fullWidth
                        size="large"
                        type="submit"
                        variant="contained"
                        loading={isSubmitting}
                        sx={{ color: 'white', fontSize: '16px' }}
                    >
                        Login
                        <Icon
                            icon="si:arrow-right-line"
                            width="24"
                            height="24"
                            style={{ marginLeft: 8 }} // add spacing between text and icon
                        />
                    </LoadingButton>


                </Stack>

                {/* <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 2 }}> */}
                {/*    <FormControlLabel */}
                {/*        disabled={disable} */}
                {/*        variant="h4" */}
                {/*        control={<Checkbox {...getFieldProps('remember')} checked={values.remember} />} */}
                {/*        label="Remember Me" */}
                {/*    /> */}

                {/*    <Link style={{ cursor: disable ? 'none' : 'auto', opacity: 0.2 }} */}
                {/*        onClick={disable ? (e) => e.preventDefault() : null} disabled={disable} component={RouterLink} variant="subtitle1" to="#"> */}
                {/*        Forgot Password? */}
                {/*    </Link> */}
                {/* </Stack> */}


            </Form>


        </FormikProvider>

    );
}
